var map = {
	"./bell.png": "./src/assets/imgs/school/bell.png",
	"./descend.png": "./src/assets/imgs/school/descend.png",
	"./faceCollectNum.png": "./src/assets/imgs/school/faceCollectNum.png",
	"./guardStuTotal.png": "./src/assets/imgs/school/guardStuTotal.png",
	"./love.png": "./src/assets/imgs/school/love.png",
	"./monthRecord/analyse.png": "./src/assets/imgs/school/monthRecord/analyse.png",
	"./monthRecord/camera.png": "./src/assets/imgs/school/monthRecord/camera.png",
	"./monthRecord/cameraCircle.png": "./src/assets/imgs/school/monthRecord/cameraCircle.png",
	"./monthRecord/care_details.png": "./src/assets/imgs/school/monthRecord/care_details.png",
	"./monthRecord/characterLine.png": "./src/assets/imgs/school/monthRecord/characterLine.png",
	"./monthRecord/checkMark.png": "./src/assets/imgs/school/monthRecord/checkMark.png",
	"./monthRecord/coach.png": "./src/assets/imgs/school/monthRecord/coach.png",
	"./monthRecord/collectCircle.png": "./src/assets/imgs/school/monthRecord/collectCircle.png",
	"./monthRecord/crisisReporting.png": "./src/assets/imgs/school/monthRecord/crisisReporting.png",
	"./monthRecord/dashboard.png": "./src/assets/imgs/school/monthRecord/dashboard.png",
	"./monthRecord/desc.png": "./src/assets/imgs/school/monthRecord/desc.png",
	"./monthRecord/emotion_overview.png": "./src/assets/imgs/school/monthRecord/emotion_overview.png",
	"./monthRecord/exponent.png": "./src/assets/imgs/school/monthRecord/exponent.png",
	"./monthRecord/figure.png": "./src/assets/imgs/school/monthRecord/figure.png",
	"./monthRecord/figureBlue.png": "./src/assets/imgs/school/monthRecord/figureBlue.png",
	"./monthRecord/gradeLeaderAppointment.png": "./src/assets/imgs/school/monthRecord/gradeLeaderAppointment.png",
	"./monthRecord/line.png": "./src/assets/imgs/school/monthRecord/line.png",
	"./monthRecord/love.png": "./src/assets/imgs/school/monthRecord/love.png",
	"./monthRecord/loveRedCircle.png": "./src/assets/imgs/school/monthRecord/loveRedCircle.png",
	"./monthRecord/makeAppointment.png": "./src/assets/imgs/school/monthRecord/makeAppointment.png",
	"./monthRecord/moreThreeTimes.png": "./src/assets/imgs/school/monthRecord/moreThreeTimes.png",
	"./monthRecord/moreTwiceCircle.png": "./src/assets/imgs/school/monthRecord/moreTwiceCircle.png",
	"./monthRecord/panel.png": "./src/assets/imgs/school/monthRecord/panel.png",
	"./monthRecord/parentalAppointment.png": "./src/assets/imgs/school/monthRecord/parentalAppointment.png",
	"./monthRecord/picture.png": "./src/assets/imgs/school/monthRecord/picture.png",
	"./monthRecord/pictureCircle.png": "./src/assets/imgs/school/monthRecord/pictureCircle.png",
	"./monthRecord/processingRate.png": "./src/assets/imgs/school/monthRecord/processingRate.png",
	"./monthRecord/rank.png": "./src/assets/imgs/school/monthRecord/rank.png",
	"./monthRecord/rank1.png": "./src/assets/imgs/school/monthRecord/rank1.png",
	"./monthRecord/rank2.png": "./src/assets/imgs/school/monthRecord/rank2.png",
	"./monthRecord/rank3.png": "./src/assets/imgs/school/monthRecord/rank3.png",
	"./monthRecord/remind.png": "./src/assets/imgs/school/monthRecord/remind.png",
	"./monthRecord/runCircle.png": "./src/assets/imgs/school/monthRecord/runCircle.png",
	"./monthRecord/screenshot.png": "./src/assets/imgs/school/monthRecord/screenshot.png",
	"./monthRecord/smallBellCircle.png": "./src/assets/imgs/school/monthRecord/smallBellCircle.png",
	"./monthRecord/star.png": "./src/assets/imgs/school/monthRecord/star.png",
	"./monthRecord/teacher_management.png": "./src/assets/imgs/school/monthRecord/teacher_management.png",
	"./monthRecord/tinkerBell.png": "./src/assets/imgs/school/monthRecord/tinkerBell.png",
	"./monthRecord/warn.png": "./src/assets/imgs/school/monthRecord/warn.png",
	"./monthRecord/warningMark.png": "./src/assets/imgs/school/monthRecord/warningMark.png",
	"./notCollectNum.png": "./src/assets/imgs/school/notCollectNum.png",
	"./photoCoverRate.png": "./src/assets/imgs/school/photoCoverRate.png",
	"./rise.png": "./src/assets/imgs/school/rise.png",
	"./user.png": "./src/assets/imgs/school/user.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imgs/school sync recursive ^\\.\\/.*\\.png$";